import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const EntityTypeSchema = z.enum(['claim', 'job']);
export const EntityIdSchema = CornSchema;
